import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { Payment } from './Payment';

const PUBLIC_KEY = "pk_test_51LNgysSCTDc3tBe9shU38kPa6Mfwe0PoqwE8uhTlcww6oAhwvMu5ozQvRos9PZ4HN0DdCoTUgUaQ2pl6jNWkWQIw00TN4KuGae";

const stripeTestPromise = loadStripe(PUBLIC_KEY);

const Stripe = () => {
  return (
    <Elements stripe={stripeTestPromise}>
      <Payment />
    </Elements>
  );
};

export default Stripe;